import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import CircularProgress from 'housecall-ui/dist/DesignSystem/Feedback/Progress/CircularProgress';
import { hideIntercom, showIntercom } from 'components/Common/Intercom/IntercomUtils';

const useStyles = makeStyles({
  iframeContainer: {
    position: 'fixed',
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 1300,
    inset: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iframe: {
    width: '80%',
    height: '80%',
    border: 'none',
  },
});

const NewCustomerDialogIframe = ({ closeDialog }) => {
  const { iframe, iframeContainer } = useStyles();
  const [isLoadingIframe, setIsLoadingIframe] = useState(true);

  const onLoadIframe = () => {
    hideIntercom();
    setIsLoadingIframe(false);
  };

  useEffect(() => {
    const handleIframeMessages = (event) => {
      if (event.data === 'closeDialog') {
        closeDialog();
        showIntercom();
      }
    };
    window.addEventListener('message', handleIframeMessages);
    return () => window.removeEventListener('message', handleIframeMessages);
  }, [closeDialog]);

  return (
    <div className={iframeContainer}>
      <iframe
        title="NewCustomerDialogBootstrap"
        className={iframe}
        src="/pro/customers/add_customer_page"
        style={{ display: isLoadingIframe ? 'none' : 'block' }}
        onLoad={onLoadIframe}
      />
      {isLoadingIframe && <CircularProgress size={60} color="secondary" />}
    </div>
  );
};

NewCustomerDialogIframe.propTypes = {
  closeDialog: PropTypes.func,
};

export default memo(NewCustomerDialogIframe);
